import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import LogoMark from './ui/LogoMark';
import { COLORS } from '../constants/theme';

const cols = [
  { heading: 'Legal',     links: [['Privacy Policy','/privacy'],['Terms of Service','/terms-of-service'],['Refund Policy','/refund-policy']] },
  { heading: 'Solutions', links: [['AI Automation','#home'],['WhatsApp Integration','#home'],['AI Platform Engineering','#home']] },
];

const socials = [
  { label:'LinkedIn',  path:'M18.8 1.8H3.16A1.33 1.33 0 001.83 3.16v15.67A1.33 1.33 0 003.16 20.17h15.64A1.33 1.33 0 0020.13 18.83V3.13A1.34 1.34 0 0018.8 1.83zM7.24 17.42H4.55V8.69H7.24v8.73zM5.88 7.48a1.57 1.57 0 110-3.14 1.57 1.57 0 010 3.14zM17.45 17.42h-2.69v-4.23c0-1-.02-2.37-1.44-2.37-1.44 0-1.66 1.12-1.66 2.28v4.32H9.02V8.69h2.63v1.21h.04c.38-.73 1.32-1.5 2.71-1.5 2.9 0 3.43 1.9 3.43 4.38v4.64h-.38z' },
  { label:'Twitter',   path:'M20.12 5.91a8.2 8.2 0 01-2.36.65 4.1 4.1 0 001.8-2.27 8.2 8.2 0 01-2.6.99 4.1 4.1 0 00-7 3.74A11.65 11.65 0 012.74 4.7a4.1 4.1 0 001.27 5.47 4.08 4.08 0 01-1.86-.51v.05a4.1 4.1 0 003.29 4.02 4.1 4.1 0 01-1.85.07 4.1 4.1 0 003.83 2.85A8.23 8.23 0 011.94 17.72a11.6 11.6 0 006.29 1.84c7.55 0 11.68-6.25 11.68-11.67l-.01-.53a8.3 8.3 0 002.04-2.11z' },
  { label:'Instagram', path:'M11.03 7.57a3.46 3.46 0 100 6.93 3.46 3.46 0 000-6.93zm0 5.71a2.25 2.25 0 110-4.5 2.25 2.25 0 010 4.5zM14.76 1.83H7.24A5.41 5.41 0 001.83 7.24v7.52a5.41 5.41 0 005.41 5.41h7.52a5.41 5.41 0 005.41-5.41V7.24a5.41 5.41 0 00-5.41-5.41zm4.17 12.93a4.17 4.17 0 01-4.17 4.17H7.24a4.17 4.17 0 01-4.17-4.17V7.24a4.17 4.17 0 014.17-4.17h7.52a4.17 4.17 0 014.17 4.17v7.52zm-2.32-8.84a1.04 1.04 0 11-2.08 0 1.04 1.04 0 012.08 0z' },
];

export default function Footer() {
  return (
    <motion.footer
      initial={{ opacity: 0 }} whileInView={{ opacity: 1 }}
      viewport={{ once: true }} transition={{ duration: 0.5 }}
      style={{ background: COLORS.blue, position: 'relative', overflow: 'hidden' }}
    >
      <div style={{
        position: 'absolute', inset: 0, pointerEvents: 'none',
        backgroundImage: 'radial-gradient(circle, rgba(255,255,255,0.06) 1px, transparent 1px)',
        backgroundSize: '28px 28px',
      }}/>

      <div className="container" style={{ position: 'relative', zIndex: 1 }}>
        <div style={{
          display: 'grid',
          gridTemplateColumns: '1.4fr repeat(2, 1fr)',
          gap: '48px 32px',
          paddingTop: 60, paddingBottom: 52,
        }} className="footer-grid">

          {/* Brand */}
          <div>
            <a href="#home" style={{ display: 'flex', alignItems: 'center', gap: 10, textDecoration: 'none', marginBottom: 16 }}>
              <div style={{
                width: 34, height: 34, borderRadius: 9,
                background: 'rgba(255,255,255,0.2)', border: '1.5px solid rgba(255,255,255,0.35)',
                display: 'flex', alignItems: 'center', justifyContent: 'center',
              }}>
                <LogoMark size={16} />
              </div>
              <span style={{ fontSize: 16, fontWeight: 700, color: COLORS.white, letterSpacing: '-0.025em' }}>Reano AI</span>
            </a>
            <p style={{ fontSize: 14, color: 'rgba(255,255,255,0.72)', lineHeight: 1.65, marginBottom: 24, maxWidth: 220 }}>
              Reano AI Technologies delivers next gen AI solutions for modern businesses.
            </p>
            <div style={{ display: 'flex', gap: 8 }}>
              {socials.map(s => (
                <a key={s.label} href="#home" aria-label={s.label} className="footer-social">
                  <svg width="16" height="16" viewBox="0 0 22 22" fill="currentColor"><path d={s.path}/></svg>
                </a>
              ))}
            </div>
          </div>

          {/* Link cols */}
          {cols.map(col => (
            <div key={col.heading}>
              <h4 style={{ fontSize: 12, fontWeight: 700, letterSpacing: '.08em', textTransform: 'uppercase', color: 'rgba(255,255,255,0.55)', marginBottom: 18 }}>
                {col.heading}
              </h4>
              <ul style={{ listStyle: 'none', padding: 0, margin: 0, display: 'flex', flexDirection: 'column', gap: 11 }}>
                {col.links.map(([label, href]) => (
                  <li key={label}>
                    {href.startsWith('/') ? (
                      <Link to={href} className="footer-link">{label}</Link>
                    ) : (
                      <a href={href} className="footer-link">{label}</a>
                    )}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* Bottom */}
        <div style={{
          borderTop: '1px solid rgba(255,255,255,0.18)',
          padding: '18px 0',
          display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: 10,
        }}>
          <div style={{ display: 'flex', gap: 20, flexWrap: 'wrap' }}>
            <Link to="/privacy" className="footer-link-sm">Privacy Policy</Link>
            <Link to="/refund-policy" className="footer-link-sm">Refund Policy</Link>
            <Link to="/" className="footer-link-sm">Legal Notice</Link>
            <Link to="/terms-of-service" className="footer-link-sm">Terms of Service</Link>
          </div>
          <p style={{ fontSize: 12.5, color: 'rgba(255,255,255,0.55)' }}>
            © {new Date().getFullYear()} Reano AI Technologies. All rights reserved.
          </p>
        </div>
      </div>

      <style>{`
        .footer-link     { font-size: 14px; color: rgba(255,255,255,0.72); text-decoration: none; transition: color .15s; }
        .footer-link:hover { color: #fff; }
        .footer-link-sm  { font-size: 12.5px; color: rgba(255,255,255,0.55); text-decoration: none; transition: color .15s; }
        .footer-link-sm:hover { color: rgba(255,255,255,0.9); }
        .footer-social   { width: 34px; height: 34px; border-radius: 8px; background: rgba(255,255,255,0.12); display: flex; align-items: center; justify-content: center; color: rgba(255,255,255,0.75); text-decoration: none; transition: background .15s, color .15s; }
        .footer-social:hover { background: rgba(255,255,255,0.22); color: #fff; }
        @media (max-width: 800px) { .footer-grid { grid-template-columns: 1fr 1fr !important; } }
        @media (max-width: 480px) { .footer-grid { grid-template-columns: 1fr !important; } }
      `}</style>
    </motion.footer>
  );
}
